import { computed, effect, untracked } from '@angular/core';
import { AuthService } from '../services/auth.service';

/** BE-1480: у вкладки есть сессия — пара токенов в authState. */
export function hasSession(auth: AuthService): boolean {
  return !!auth.authState().tokens;
}

/**
 * BE-1480: сбросить данные пользователя, когда у вкладки кончилась сессия. Root-сервисы живут на всю
 * вкладку, а выход её не перезагружает: без сброса следующий вошедший в той же вкладке видел бы данные
 * прошлого. Конец сессии — пара токенов пропала из authState, каким бы путём (кнопка «Выход», 401,
 * неудачное обновление токена). Обновление токена той же сессией пару не убирает и сброса не вызывает.
 *
 * Вызывать в injection context — в конструкторе или поле сервиса.
 */
export function resetOnSessionEnd(auth: AuthService, reset: () => void): void {
  const signedIn = computed(() => hasSession(auth));
  effect(() => {
    if (!signedIn()) untracked(reset);
  });
}
